import { __awaiter } from '../node_modules/tslib/tslib.es6.js';
import { isBrowser } from '@websolutespa/bom-core';
import { MessageDecoder } from './message.service.js';
import { getMockApp } from './mock.js';
import { messagesToHistory } from './useLlm.js';

class ApiService {
  constructor(options) {
    this.options = options;
  }
  get apiUrl() {
    const origin = this.options.endpoint || (isBrowser ? window.location.origin : process.env.STORE_URL);
    const apiUrl = `${origin}/api`;
    return apiUrl;
  }
  get baseUrl() {
    const baseUrl = `${this.apiUrl}/llm`;
    return baseUrl;
  }
  get(pathname) {
    return __awaiter(this, void 0, void 0, function* () {
      const url = `${this.baseUrl}${pathname}${pathname.indexOf('?') !== -1 ? '&' : '?'}locale=${this.options.locale}`;
      try {
        const response = yield fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (response.ok) {
          const data = yield response.json();
          return data;
        } else {
          console.error('useLlm.api.get', url, response);
          return undefined;
        }
      } catch (error) {
        console.error('useLlm.api.get', url, error);
        return undefined;
      }
    });
  }
  post(pathname, payload) {
    return __awaiter(this, void 0, void 0, function* () {
      const options = this.options;
      const url = `${this.baseUrl}${pathname}${pathname.indexOf('?') !== -1 ? '&' : '?'}locale=${options.locale}`;
      try {
        const response = yield fetch(url, {
          method: 'POST',
          body: JSON.stringify(Object.assign(Object.assign({}, options), payload)),
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (response.ok) {
          const data = yield response.json();
          return data;
        } else {
          console.error('useLlm.api.post', response, url);
          return undefined;
        }
      } catch (error) {
        console.error('useLlm.api.post', error, url);
        return undefined;
      }
    });
  }
  fetch(pathname, init) {
    return __awaiter(this, void 0, void 0, function* () {
      const options = this.options;
      const url = `${this.apiUrl}${pathname}${pathname.indexOf('?') !== -1 ? '&' : '?'}locale=${options.locale}`;
      try {
        const response = yield fetch(url, init);
        if (response.ok) {
          const data = yield response.json();
          return data;
        } else {
          console.error('useLlm.api.fetch', response, url);
          return undefined;
        }
      } catch (error) {
        console.error('useLlm.api.fetch', error, url);
        return undefined;
      }
    });
  }
  getInfo(payload) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.options.test) {
        return this.getInfoMock(payload);
      }
      const app = yield this.post('/info', payload);
      return app;
    });
  }
  upload(upload) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.options.test) {
        const uploaded = {
          id: upload.file.name,
          name: upload.file.name,
          filename: upload.file.name,
          mimeType: upload.file.type,
          filesize: upload.file.size,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          url: upload.file.type.indexOf('image') === 0 ? upload.base64 : `//${upload.file.name}`,
          type: upload.file.type.indexOf('image') === 0 ? 'image' : 'file'
        };
        return uploaded;
      }
      const data = new FormData();
      Object.entries(this.options).forEach(entry => {
        data.set(entry[0], String(entry[1]));
      });
      data.set('file', upload.file, upload.file.name);
      const uploaded = yield this.fetch('/llmUserUpload/upload', {
        method: 'POST',
        body: data
      });
      return uploaded && Object.assign(Object.assign({}, uploaded), {
        type: uploaded.mimeType.indexOf('image') === 0 ? 'image' : 'file'
      });
    });
  }
  decorateHistory(storedHistory_1) {
    return __awaiter(this, arguments, void 0, function (storedHistory, mode) {
      var _this = this;
      if (mode === void 0) {
        mode = 'default';
      }
      return function* () {
        // console.log('ApiService.decoratedHistory.storedHistory', storedHistory);
        if (storedHistory.length > 0) {
          const threadIds = storedHistory.reduce((p, c) => {
            if (!p.includes(c.threadId)) {
              p.push(c.threadId);
            }
            return p;
          }, []);
          // console.log('ApiService.decoratedHistory.threadIds', threadIds);
          const decodedThreads = {};
          for (const threadId of threadIds) {
            const app = yield _this.getInfo({
              threadId
            });
            // console.log('ApiService.decoratedHistory.thread', app?.thread);
            if (app === null || app === void 0 ? void 0 : app.thread) {
              const decodedThread = MessageDecoder.decodeThread(app.thread);
              // console.log('ApiService.decoratedHistory.decodedThread', decodedThread);
              if (decodedThread) {
                decodedThreads[threadId] = decodedThread;
              }
            }
          }
          // console.log('ApiService.decoratedHistory.decodedThreads', decodedThreads);
          const history = storedHistory.map((_ref, i) => {
            let {
              threadId,
              messageId
            } = _ref;
            const decodedThread = decodedThreads[threadId];
            if (decodedThread) {
              decodedThread.messages.forEach(x => {
                if (x.role === 'assistant') {
                  x.threadId = threadId;
                  // this should fix old history missing messageId;
                  if (!x.messageId && mode !== 'page') {
                    x.messageId = messageId;
                  }
                }
              });
              const index = _this.options.test ? i + 1 : decodedThread.messages.findIndex(x => x.messageId === messageId);
              // console.log('ApiService.decoratedHistory.index', index);
              if (index !== -1) {
                const messages = decodedThread.messages.slice(0, index + 1);
                // console.log('ApiService.decoratedHistory.messages', messages);
                if (_this.options.test) {
                  messages[index].threadId = threadId;
                  messages[index].messageId = messageId;
                  messages[index].createdAt = new Date().toISOString();
                }
                const histories = messagesToHistory(messages);
                // console.log('ApiService.decoratedHistory.histories', histories);
                return histories[0];
              }
              return undefined;
            }
            return undefined;
          }).filter(x => x !== undefined);
          // console.log('ApiService.decoratedHistory.history', history);
          history.sort((a, b) => {
            if (a.createdAt && b.createdAt) {
              return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
            }
            return 0;
          });
          if (mode !== 'page') {
            const chatHistory = history.reduce((p, c) => {
              if (p.findIndex(x => x.threadId === c.threadId) === -1) {
                p.push(c);
              }
              return p;
            }, []);
            // console.log('ApiService.decoratedHistory.chatHistory', chatHistory);
            return chatHistory;
          }
          return history;
        }
        return [];
      }();
    });
  }
  getInfoMock(payload) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        locale,
        appKey,
        apiKey,
        threadId
      } = Object.assign(Object.assign({}, this.options), payload);
      if (typeof locale !== 'string') {
        throw {
          status: 400,
          message: 'Bad Request: locale is missing'
        };
      }
      if (!appKey) {
        throw {
          status: 401,
          message: 'Unauthorized: appKey is missing'
        };
      }
      if (!apiKey) {
        throw {
          status: 401,
          message: 'Unauthorized: apiKey is missing'
        };
      }
      const app = getMockApp(locale, threadId, this.options.test);
      return app;
    });
  }
  postSummary(payload) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.options.test) {
        return this.postSummaryMock(payload);
      }
      const response = yield this.post('/summary', payload);
      return response;
    });
  }
  postSummaryMock(payload) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        locale,
        appKey,
        apiKey,
        threadId
      } = this.options;
      if (typeof locale !== 'string') {
        throw {
          status: 400,
          message: 'Bad Request: locale is missing'
        };
      }
      if (!appKey) {
        throw {
          status: 401,
          message: 'Unauthorized: appKey is missing'
        };
      }
      if (!apiKey) {
        throw {
          status: 401,
          message: 'Unauthorized: apiKey is missing'
        };
      }
      if (!threadId) {
        throw {
          status: 400,
          message: 'Bad Request: threadId is missing'
        };
      }
      const {
        email,
        html
      } = payload;
      if (!email) {
        throw {
          status: 400,
          message: 'Bad Request: email is missing'
        };
      }
      if (!html) {
        throw {
          status: 400,
          message: 'Bad Request: html is missing'
        };
      }
      // console.log('/llm/summary', payload);
      return {
        code: 'SENT'
      };
    });
  }
  postFeedback(feedback) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.options.test) {
        return this.postFeedbackMock(feedback);
      }
      const response = yield this.post('/feedback', feedback);
      return response;
    });
  }
  postFeedbackMock(feedback) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        locale,
        appKey,
        apiKey
      } = this.options;
      if (typeof locale !== 'string') {
        throw {
          status: 400,
          message: 'Bad Request: locale is missing'
        };
      }
      if (!appKey) {
        throw {
          status: 401,
          message: 'Unauthorized: appKey is missing'
        };
      }
      if (!apiKey) {
        throw {
          status: 401,
          message: 'Unauthorized: apiKey is missing'
        };
      }
      const {
        threadId,
        messageId,
        feedbackRating
      } = feedback;
      if (!threadId) {
        throw {
          status: 400,
          message: 'Bad Request: threadId is missing'
        };
      }
      if (!messageId) {
        throw {
          status: 400,
          message: 'Bad Request: messageId is missing'
        };
      }
      if (!feedbackRating) {
        throw {
          status: 400,
          message: 'Bad Request: feedbackRating is missing'
        };
      }
      // console.log('/llm/feedback', feedback);
      return {
        code: 'SENT'
      };
    });
  }
}

export { ApiService };
//# sourceMappingURL=api.service.js.map
